// TODO resolve accessibility issues

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';

import SpriteSheet from 'shopper/components/SpriteSheet';
import Text from 'shopper/components/Text';

import { toThreadLink } from 'lib/links';

const CategoriesCarouselItem = ({
  categoryIcon,
  categoryTitle,
  categorySlug,
  className,
  onClick,
  ...rest
}) => (
  <NextLink href={toThreadLink(categorySlug)} prefetch={false} passHref>
    <a
      aria-label={`ir para a categoria ${categoryTitle}`}
      className={twMerge(
        'mr-2 flex flex-col items-center justify-center py-4',
        className
      )}
      onClick={onClick}
      {...rest}
    >
      <div className="mb-2 flex size-12 items-center justify-center rounded-full bg-neutral-high-200 dark:bg-neutral-low-200">
        <SpriteSheet
          className="size-6"
          icon={categoryIcon}
          sheet="forum-categories-carousel"
          aria-hidden
        />
      </div>
      <Text className="text-center" size="size2">
        {categoryTitle}
      </Text>
    </a>
  </NextLink>
);

CategoriesCarouselItem.propTypes = {
  categoryIcon: PropTypes.string.isRequired,
  categoryTitle: PropTypes.string.isRequired,
  categorySlug: PropTypes.string.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onClick: PropTypes.func.isRequired,
};

export default memo(CategoriesCarouselItem);
